<div
  [ngClass]="{ editing: this.isEditing, 'full-screen': fullScreen, 'full-network-upload': this.networkUpload }"
  class="modal solid"
  id="UploadEntitiesModal"
  >
  <div class="fullRow">
    <div class="title" style="filter: brightness(50%)">
      <span>Upload {{ this.resourceLabel }}</span>
    </div>
    @if (!isEditing || !showTable) {
      <div [hidden]="networkUpload" class="subtitle">
        Upload your {{ resourceLabel }} as code
      </div>
    }
    @if (isEditing && showTable) {
      <div class="subtitle">
        Double click to edit cell values. Single click to open advanced editor.
      </div>
    }
    <div class="sized">
      <div id="EntitiesBulkUpload">
        <div class="label filterRow row">
          <span
            (click)="toggleFilter()"
            [hidden]="(!isEditing || !invalid) && !showInvalid"
            class="filter-label"
            >{{ invalid || showInvalid ? (!showInvalid ? 'Show Invalid' : 'Show All') : '' }}</span
            >
            <span [hidden]="!invalid || fileEmpty" class="invalidMessage"
              >Upload file is invalid. Please check content and try again.</span
              >
              <span [hidden]="!invalid || !fileEmpty" class="invalidMessage"
                >Upload file is empty. Please check content and try again</span
                >
                @if (isEditing && showTable) {
                  <div
                    (click)="actionButton()"
                    [ngClass]="actionButtonClass"
                    class="actionButton"
                  ></div>
                }
                @if (fileIsReady && isEditing && showTable) {
                  <span class="row-count-edit"
                    >{{ fileObj.length }} of {{ fileObj.length }}</span
                    >
                  }
                </div>
                @if (!isEditing) {
                  <div
                    (drop)="fileDrop($event)"
                    [ngClass]="{ invalid: invalid, valid: !invalid && fileIsReady }"
                    [uploader]="uploader"
                    class="uploadArea"
                    ng2FileDrop
                    >
                    <div [hidden]="fileIsReady" class="label">Drag and drop a JSON or YML file</div>
                    <div [hidden]="fileIsReady" class="sublabel">
                      or
                      <div (click)="showDialog()" class="linkButton" id="EndpointFileUpload">
                        Select a file from your computer
                      </div>
                      <form [formGroup]="form">
                        <input
                          #fileInput
                          (change)="onFileChange($event)"
                          id="FileSelect"
                          name="file"
                          style="display: none"
                          type="file"
                          />
                        </form>
                      </div>
                      @if (fileIsReady && !isEditing && !showTable && !importError) {
                        <span class="row-count"
                          >{{ fileObj.length }} {{ resourceLabel }}</span
                          >
                      }
                      @if (!invalid) {
                        <div>
                          <div [hidden]="!fileIsReady" class="label">Click "Upload" to create {{ resourceLabel }}</div>
                          @if (fileIsReady) {
                            <div (click)="showDialog()" class="linkButton">
                              or choose a different file
                            </div>
                          }
                        </div>
                      }
                      @if (invalid) {
                        <div>
                          <div [hidden]="!fileIsReady" class="label">Invalid {{ resourceLabel }}</div>
                          <div class="linkContainer">
                            @if (!importError) {
                              <div class="linkPrefix">Edit data or</div>
                            }
                            @if (fileIsReady) {
                              <div (click)="showDialog()" class="linkButton">
                                choose a different file
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                  <div [hidden]="!isEditing" class="code-editor-container">
                    <div #editor [hidden]="!isEditing || showTable" class="code-editor"></div>
                    @if (showTable && !tableRefresh) {
                      <app-data-table
                        (gridReady)="onGridReady($event)"
                        [columnDefinitions]="columnDefs"
                        [ngClass]="{ invalid: invalid, valid: !invalid && fileIsReady }"
                        [rowData]="fileObj"
                        [rowValidation]="rowValidation"
                        [rowsToggled]="rowsToggled.bind(this)"
                        [tableId]="resourceType + '_upload'"
                        [validateService]="validate.bind(this)"
                        [view]="'upload'"
                        class="edit-upload-table"
                        >
                      </app-data-table>
                    }
                  </div>
                </div>
                <div class="row buttonRow right">
                  @if (fileIsReady && isEditing && showTable && buttonAction === 'remove') {
                    <button
                      (click)="copyData()"
                      [disabled]="importing"
                      class="save"
                      id="CopyButton"
                      >
                      Copy
                    </button>
                  }
                  @if (fileIsReady && !isEditing && !importError) {
                    <button
                      (click)="toggleEditor()"
                      [disabled]="importing"
                      class="save"
                      id="EditUploadButton"
                      >
                      Edit
                    </button>
                  }
                  @if (fileIsReady && isEditing && !showTable) {
                    <button
                      (click)="toggleTable()"
                      [disabled]="importing"
                      class="save"
                      id="TableEditButton"
                      >
                      Show Table
                    </button>
                  }
                  @if (fileIsReady && isEditing && showTable) {
                    <button
                      (click)="toggleTable()"
                      [disabled]="importing"
                      class="save"
                      id="SourceEditButton"
                      >
                      View Source
                    </button>
                  }
                  @if (fileIsReady && isEditing) {
                    <button
                      (click)="toggleEditor()"
                      [disabled]="importing"
                      class="save"
                      id="DoneEditUploadButton"
                      >
                      Done
                    </button>
                  }
                  @if (!importing && !isEditing) {
                    <button
                      (click)="uploadResources()"
                      [disabled]="!fileIsReady || invalid"
                      class="save"
                      id="UploadEndpointsButton"
                      >
                      Upload
                    </button>
                  }
                  @if (importing) {
                    <button class="save confirm" disabled>Uploading <span class="spinner"></span></button>
                  }
                </div>
              </div>
              <div (click)="toggleModalSize()" class="buttonBall resize" id="ResizeModalButton"></div>
              <div (click)="hide()" class="buttonBall close" id="EscUploadEntitiesClose"></div>
            </div>
          </div>
